<template>
  <v-container column>
    <v-layout row align-center>

      <ima-logo />

      <div v-if="showNavLinks" class="admin-nav ml-3">
        <v-btn
          v-for="item in primaryNav"
          :key="item.route"
          flat
          small
          class="admin-nav__link"
          :class="{ 'admin-nav__link--active': isActive(item) }"
          :to="{ name: item.route }">
          <v-icon small class="mr-2">{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
      </div>

      <v-spacer></v-spacer>
      <settings-menu :extra-items="collapsedNav"/>
      <account-dropdown/>
    </v-layout>
  </v-container>
</template>

<script>
import AccountDropdown from '@/components/base/AccountDropdown';
import SettingsMenu from '@/components/base/SettingsMenu';
import ImaLogo from "@/components/base/ImaLogo";
import { primaryNav } from '@/components/base/adminMenu';

export default {
  name: 'AdminHeader',
  components: {
    AccountDropdown,
    SettingsMenu,
    ImaLogo,
  },
  data() {
    return {
      primaryNav,
    };
  },
  computed: {
    showNavLinks() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    // Sem espaço na barra, os links voltam para dentro da engrenagem.
    collapsedNav() {
      return this.showNavLinks ? [] : primaryNav;
    },
  },
  methods: {
    isActive(item) {
      return this.$route.path.startsWith(item.match);
    },
  },
};
</script>

<style scoped lang="scss">

  .container{
    max-width: 100% !important;
    padding: 0 !important;
  }

  .admin-nav {
    display: flex;
    align-items: center;
  }

  // A toolbar do admin é verde/dark, então os links já herdam texto branco:
  // o estado ativo se distingue pelo contraste, não pela cor.
  .admin-nav__link {
    opacity: 0.9;
  }

  .admin-nav__link--active {
    opacity: 1;
    font-weight: 600;
  }
</style>
